const tableStyles = {
  // table: {
  //   style: {
  //     overflowY: 'auto',
  //     overflowX: 'hidden',
  //   },
  // },
  header: {
    style: {
      backgroundColor: '#FAFAFA',
    },
  },
  headRow: {
    style: {
      backgroundColor: '#E0E0E0',
      border: 'none',
      height: '38px',
      color: '#161616',
    },
  },
  headCells: {
    style: {
      fontSize: '14px',
      lineHeight: '18px',
    },
  },
  rows: {
    highlightOnHoverStyle: {
      backgroundColor: '#FFF',
      cursor: 'pointer',
      borderBottomColor: '#FFFFFF',
      outline: '1px solid #FFFFFF',
    },
    style: {
      backgroundColor: '#F3F3F3',
      fontSize: '13px',
      linHeight: '17px',
      color: '#525252',
    },
  },
  pagination: {
    style: {
      backgroundColor: '#FAFAFA',
      'select': {
        height: '24px !important',
      },
    },
  },
  noData: {
    style: {
      backgroundColor: '#E0E0E0',
      color: '#515151',
    },
  },
};

export { tableStyles };